import React from 'react';
import { useVersionCheck } from '../hooks/useVersionCheck';

const UpdateNotification: React.FC = () => {
  const { updateAvailable, refresh, dismiss } = useVersionCheck();

  if (!updateAvailable) return null;

  return (
    <div style={{
      position: 'fixed',
      bottom: '1rem',
      left: '50%',
      transform: 'translateX(-50%)',
      background: 'linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)',
      color: 'white',
      padding: '0.75rem 1.5rem',
      borderRadius: '0.5rem',
      boxShadow: '0 4px 12px rgba(0,0,0,0.3)',
      display: 'flex',
      alignItems: 'center',
      gap: '1rem',
      zIndex: 9999,
      fontSize: '0.875rem'
    }}>
      <span>A new version is available</span>
      <button
        onClick={refresh}
        style={{
          background: 'white',
          color: '#1d4ed8',
          border: 'none',
          padding: '0.375rem 0.75rem',
          borderRadius: '0.25rem',
          fontWeight: 600,
          cursor: 'pointer'
        }}
      >
        Refresh
      </button>
      <button
        onClick={dismiss}
        style={{
          background: 'transparent',
          color: 'white',
          border: 'none',
          fontSize: '1.25rem',
          cursor: 'pointer',
          opacity: 0.7
        }}
      >
        ×
      </button>
    </div>
  );
};

export default UpdateNotification;
